<forge-select [disabled]="isViewOnly" [name]="Name" attr.telemetry="Submission-{{Label}}" [value]="selected"
  [selectOnBlur]="selectOnBlur" [required]="isRequired && !forCellEdit" (change)="fireValueChanged($event)"
  [invalid]="isInvalid" [(ngModel)]="selected" focusOnLoad [forCellEdit]="forCellEdit"
  [propertyMetadata]="propertyMetadata" [id]="controlId" [density]="Density" (focus)="onFocus()"
  [ngClass]="{'dense-input': dense || compact, 'cell-edit': forCellEdit}" (keydown)="onKeyDown($event)"
  [attr.label-position]="LabelPosition" [label]="Label" [aria-label]="Label" [attr.shape]="forCellEdit ? 'squared' : null">
  @for (item of options; track item) {
    <forge-option [value]="item.Key">
      {{item.Value}}
    </forge-option>
  }
  @if (hint && !dense && !compact) {
    <span slot="support-text">{{hint}}</span>
  }
  @if (error && !dense && !compact) {
    <span slot="support-text" class="error-red">{{error}}</span>
  }
  @if (showSpinner) {
    <forge-circular-progress slot="end" class="metadata-input--spinner">
    </forge-circular-progress>
  }
</forge-select>